module.exports = __webpack_public_path__ + "img/plus-blue.e8b139d4.svg";